import { all, call, put, takeEvery } from "@redux-saga/core/effects";
import { OpService } from "../../services/operation";
import { showErrorResponse } from "../../varibles/global";
import { operationActions } from "./reducer";


function* getStarvingWatcher() {
    try {
        const data: string[][] = yield call(OpService.starvings);
        yield put(operationActions.getStarvingSuccess(data));
    } catch (error) {
        yield put(operationActions.getStarvingFailure())
        showErrorResponse('Get data failure', error);
    }
}


export default function* operationSaga() {
    yield all([
        takeEvery(operationActions.getStarving.type, getStarvingWatcher),
    ])
}
